import { render, staticRenderFns } from "./devolucao.vue?vue&type=template&id=4f220506&scoped=true"
import script from "./devolucao.vue?vue&type=script&lang=js"
export * from "./devolucao.vue?vue&type=script&lang=js"
import style0 from "./devolucao.vue?vue&type=style&index=0&id=4f220506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f220506",
  null
  
)

export default component.exports